import React from 'react';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.png';


const Footer = () => {
    return (
        <>
            <footer className="footer">
                <Container>
                    <Row>
                        {/* Logo + About */}
                        <Col md={4} className="mb-4 mb-md-0">
                            <div className='footer-logo'><Image src={logo} alt="Logo" /></div>
                            <p>
                                Clipnest Studio turns your raw footage into captivating stories. We deliver fast, affordable, and polished edits that elevate your brand — every single time.
                            </p>
                        </Col>

                        {/* Quick Links */}
                        <Col md={4} className="mb-4 mb-md-0">
                            <h5>Quick Links</h5>
                            <ul className="list-unstyled">
                                <li><Link to="/support">Support</Link></li>
                                <li><Link to="/terms-and-condition">Terms and condition</Link></li>
                                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                            </ul>
                        </Col>

                        {/* Download Button */}
                        <Col md={4}>
                            <h5>Get Our App</h5>
                            <Button
                                variant="light"
                                href="https://play.google.com/store"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="playstore-btn"
                            >
                                <span className="visually-hidden">Download on Play Store</span>
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </footer>
            <div className="footer-coppy">
                Copyrights © 2025 Clipnest Studio. All Rights Reserved.
            </div>
        </>
    );
};

export default Footer;
